export default __webpack_public_path__ + "static/media/avoidentrapment.39f848d8.png";